export default __webpack_public_path__ + "static/movie-15634a7bd4ae6288aced799406c614ee.png";